export const OverflowedElementsShadow = () => (
  <div className="absolute end-0 inset-y-0 w-6 bg-gradient-to-l rtl:bg-gradient-to-r from-[var(--ds-tab-inactive-bg)] pointer-events-none" />
);
